import React from "react";
import { Control } from "react-hook-form";
import { Grid } from "@mui/material";
import { ControlledTextField } from "../forms/ControlledTextField";
import { AsyncSelect } from "../forms/AsyncSelect";
import { HttpCache } from "../../http";
import { OrderDeliveryAddressFields } from "../../types/purchaseOrder/Order";
import { CHECKOUT_MAXLEN } from "../../utils/checkoutFieldMaxLengths";

interface AddressFieldsProps {
    control: Control<any>;
    baseName: string;
    showCP?: boolean;
}

export const AddressFields: React.FC<AddressFieldsProps> = ({
    control,
    baseName,
    showCP = true,
}) => (
    <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 8 }}>
            <ControlledTextField
                control={control}
                label="Calle"
                name={`${baseName}.${OrderDeliveryAddressFields.Street}`}
                required
                inputProps={{ maxLength: CHECKOUT_MAXLEN.vchCalle }}
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
            <ControlledTextField
                control={control}
                label="Número"
                name={`${baseName}.${OrderDeliveryAddressFields.StreetNumber}`}
                inputProps={{ maxLength: CHECKOUT_MAXLEN.vchCalleNro }}
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
            <ControlledTextField
                control={control}
                label="Piso / Departamento"
                name={`${baseName}.${OrderDeliveryAddressFields.FloorApartment}`}
                inputProps={{ maxLength: CHECKOUT_MAXLEN.vchPisoDpto }}
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
            <AsyncSelect
                label="Provincia"
                loadOptions={HttpCache.getProvincies}
                control={control}
                name={`${baseName}.${OrderDeliveryAddressFields.ProvinceCode}`}
                required
            />
        </Grid>
        <Grid size={{ xs: 12, sm: showCP ? 8 : 12 }}>
            <ControlledTextField
                control={control}
                label="Localidad"
                name={`${baseName}.${OrderDeliveryAddressFields.LocalityDesc}`}
                required
                inputProps={{ maxLength: CHECKOUT_MAXLEN.vchDescLocalidad }}
            />
        </Grid>
        {showCP && (
            <Grid size={{ xs: 12, sm: 4 }}>
                <ControlledTextField
                    control={control}
                    label="Código Postal"
                    name={`${baseName}.${OrderDeliveryAddressFields.ZipCode}`}
                    required
                    inputProps={{ maxLength: 10 }}
                />
            </Grid>
        )}
    </Grid>
);
